import { StandardEvents } from '@shopify/events';

/**
 * Wedwyn: keeps a server-rendered block in step with the selected variant (docs/30_PAGES/PRODUCT.md A-04, A-06).
 * When the variant picker fetches the section for a new variant, the block with the same data-block-id in that HTML
 * replaces this block's content — same approach as Horizon's product-price.js.
 */
class WedwynVariantSync extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(StandardEvents.productSelect, this.#onProductSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.#onProductSelect);
  }

  #onProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        if (!detail.newProduct && detail.productId && detail.productId !== this.dataset.productId) return;
        const fresh = detail.html.querySelector(`wedwyn-variant-sync[data-block-id="${this.dataset.blockId}"]`);
        if (fresh) this.innerHTML = fresh.innerHTML;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[wedwyn-variant-sync] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('wedwyn-variant-sync')) {
  customElements.define('wedwyn-variant-sync', WedwynVariantSync);
}
